import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// Cherche #xsavier-root (intégration Prestashop) puis fallback #root (build Vite)
const root =
  document.getElementById("xsavier-root") || document.getElementById("root");
if (!root) {
  console.error("[xsavier] ni #xsavier-root ni #root trouvé dans le DOM");
} else {
  const token =
    (root as HTMLElement).dataset.customerToken ||
    new URLSearchParams(window.location.search).get("token") ||
    "";
  if (!token) {
    root.innerHTML =
      '<div style="padding:1rem;color:#b91c1c">Xsavier: aucun token fourni (data-customer-token manquant ou ?token= absent)</div>';
  } else {
    createRoot(root).render(
      <StrictMode>
        <App prestashopToken={token} />
      </StrictMode>,
    );
  }
}
